import React from 'react';

import { StaticQuery, graphql } from "gatsby"

import AnniversaryLogo from '../images/90-anniversary-logo.png';
import '../css/logo.css';
import AnnLogo from '../images/anniversary_logo';


export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        wp {
          acfOptionsHeader {
            themeOptionsHeader {
              primaryLogo {
                altText
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    `}

    render={data => {
      const { primaryLogo } = data.wp.acfOptionsHeader.themeOptionsHeader;
      let image = primaryLogo

      if(props.logo)
        image = props.logo;

      return (
        <div className="nav-logos">
         <div className="main-nav-logo">
          <img className={props.className} src={(image && image.localFile && image.localFile.publicURL) && image.localFile.publicURL} alt={(image && image.altText) ? image.altText : ''} />
          </div>
         <div className="nav-anniversary-logo">
          <AnnLogo className="ann-logo"/>
          {/* <img src={AnniversaryLogo} alt="Anniversary Logo" /> */}
          </div>
          </div>
      );
    }
  }
  />
)